import { useEffect } from "react";
import {
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";

export default function NotFound() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "404", "404 - Not Found");

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className={"Background404"}>
      <img src={"/images/404.svg"} alt="404" />
    </div>
  );
}
